// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + ".chunk." + {"36":"454a8ed6","98":"81c80f2b","278":"a65618de","311":"38d875df","337":"84ae190b","412":"fdf77fed","649":"d304da91","661":"74c8994c","663":"42259a47","690":"d61a0350","692":"9587fc9b","874":"e18ab46d","876":"06f19a32"}[chunkId] + ".js";
};